import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { UserGroupService, UserGroupSettingEditGet } from '@app/services/user-group.service';

@Component({
    selector: 'tt-usergroup-setting-edit',
    templateUrl: './usergroup-setting-edit.component.html',
    styleUrls: ['./usergroup-setting-edit.component.css'],
    standalone: false
})
export class UsergroupSettingEditComponent implements OnInit, OnChanges {
    @Input()
    public itemId?: string | number;

    @Output()
    public onSave = new EventEmitter<void>();

    public page?: UserGroupSettingEditGet;

    public saving = false;

    public error = '';

    public readonly tablet: MediaQueryList;

    private key?: string | number;

    private started = false;

    constructor(
        private readonly groups: UserGroupService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.tablet = layout.getMediaQueries().tablet;
    }

    public async ngOnInit(): Promise<void> {
        if (this.started) return;

        this.key = this.itemId ?? this.navigator?.params['item_id'] as string | number | undefined;

        await this.loadPage();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!changes['itemId']) return;

        if (this.itemId) this.key = this.itemId;
        else if (this.key === undefined) this.key = this.navigator?.params['item_id'] as string | number | undefined;

        void this.loadPage();
    }

    private async loadPage(): Promise<void> {
        if (!this.key) return;

        this.started = true;

        try {
            this.page = await this.groups.getSettingEdit({ p2_usergroup_setting_keyno: this.key });
        } catch (error) {
            this.showError(error);
        }
    }

    public async save(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.groups.saveSetting(this.page);

            this.saving = false;

            if (this.onSave.observed && this.tablet.matches) this.onSave.emit();
            else this.navigator?.back();
        } catch (error) {
            this.showError(error);
        } finally {
            this.saving = false;
        }
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
